import {RemotePostConfirmPhone} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';
import {PostConfirmPhone} from 'domain/usecases';

export const makePostConfirmPhone = (): PostConfirmPhone =>
	new RemotePostConfirmPhone(
		makeBFFApiUrl(ProfileChangeDataEndpoints.checkCellPhone),
		makeAuthorizeHttpClientDecorator(),
	);
